import { isPresent } from "neetocist";
import { Tooltip } from "neetoui";
import { Switch as FormikSwitch } from "neetoui/formik";

const TooltipSwitch = ({
  enabledCondition,
  name = "",
  isDisabled = false,
  switchDataTestid,
  tooltipProps = {},
  ...otherProps
}) => {
  const { enabledSwitchText, disabledSwitchText, ...neetoUITooltipProps } =
    tooltipProps;

  const tooltipContent = enabledCondition
    ? enabledSwitchText
    : disabledSwitchText;

  return (
    <Tooltip
      content={tooltipContent}
      disabled={!tooltipContent}
      position="top"
      {...neetoUITooltipProps}
    >
      <span>
        <FormikSwitch
          disabled={isDisabled}
          data-testid={
            isPresent(switchDataTestid)
              ? switchDataTestid
              : "toggle-feature-card-switch"
          }
          {...{ name, ...otherProps }}
        />
      </span>
    </Tooltip>
  );
};

export default TooltipSwitch;
